import * as React from 'react';
import classnames from 'classnames';
import Icon from './icon';
import { TestResult } from '../infrastructure/toolbox';

import './listbox.scss';

export interface ListboxItemProps {
	className?: string;
}

export interface ListboxProps {
	items: any[];
	name?: string;
	height?: string;
	className?: string;
	listItemStyle?: 'error-message' | 'text-result';
	template?: (data: any) => JSX.Element;
}

const ListBoxItem: React.FC<ListboxItemProps> = props => {
	return <div className={classnames('listbox-item', props.className)}>{props.children}</div>;
};
const TextResultItem: React.FC<{ data: TestResult }> = props => {
	return (
		<ListBoxItem className={classnames('li-test-result', { 'li-tr-error': !props.data.isPassed })}>
			<Icon icon={props.data.isPassed ? 'check' : 'uncheck'} />
			{props.data.test}
		</ListBoxItem>
	);
};
const ErrorMessageItem: React.FC<{ data: string }> = props => {
	return (
		<ListBoxItem className='li-error-message'>
			<Icon icon='warning' />
			{props.data}
		</ListBoxItem>
	);
};
export class Listbox extends React.PureComponent<ListboxProps> {
	static defaultProps: ListboxProps = {
		items: [],
	};
	getRowTemplate() {
		switch (this.props.listItemStyle) {
			case 'text-result':
				return (data: any) => <TextResultItem data={data} />;
			case 'error-message':
				return (data: any) => <ErrorMessageItem data={data} />;
			default: {
				if (this.props.template) return this.props.template;

				return (data: any) => <ListBoxItem>{data}</ListBoxItem>;
			}
		}
	}
	render() {
		const props = this.props;
		var tempate = this.getRowTemplate();
		return (
			<div className={classnames('listbox', props.className)}>
				<div className='listbox-name'>{props.name}</div>
				<div style={{ height: props.height }} className='listbox-body'>
					{this.props.items.map((item, index) => React.cloneElement(tempate(item), { key: index }))}
				</div>
			</div>
		);
	}

	static Item = ListBoxItem;
}

export default Listbox;
